/* eslint-disable */
import React, { useEffect, useContext, useState } from "react";
import { Link } from "react-router-dom";

import { assetImages } from "constants";
/*import url and gateway methods */
import { postData, putData, uploadMultipleFile, getData } from "utils/Gateway";
import * as url from "helper/UrlHelper";
import downloadFileHandler from "helper/DownloadFile";
import {
  getDateFormatInSpanish,
  getFileIcon,
} from "helper/Common/CommonHelper";

const ViewTaskTab = ({
  selectedTaskId,
  setShowAlert,
  setAlertMessage,
  setMessageType,
}) => {
  const todayValue = new Date().toISOString().split("T")[0];

  const token = localStorage.getItem("token"); // token
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const [taskModerator, settaskModerator] = useState(null);
  const [userName, setUserName] = useState("");
  const [userImage, setUserImage] = useState("");
  const [taskFollowers, setTaskFollowers] = useState([]);
  const [projectName, setprojectName] = useState("");
  const [projectId, setprojectId] = useState(null);
  const [customId, setCustomId] = useState(null);
  const [title, settitle] = useState("");
  const [details, setdetails] = useState("");
  const [startDate, setstartDate] = useState("");
  const [endDate, setendDate] = useState("");
  const [hours, sethours] = useState("");
  const [price, setPrice] = useState("");
  const [priority, setpriority] = useState("");
  const [taskStatus, settaskStatus] = useState("");
  const [uploadedDocFiles, setUploadedDocFiles] = useState([]);
  const [childTasks, setchildTasks] = useState([]);

  const [showTaskHourInput, setShowTaskHourInput] = useState(false);
  const [showTaskDateInput, setShowTaskDateInput] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  //function for get project details
  const getTaskDetails = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_TASK_DETAILS +
        `/${selectedTaskId}?token=${token}`;

      const response = await getData(requestUrl);

      console.log("response in view task details", response);

      if (response.status && response.data) {
        setCustomId(response.data.customid);
        settitle(response.data.title);
        setdetails(response.data.description);
        setUserName(response.data.assignedusername);
        setUserImage(response.data.assigneduserimage);
        setTaskFollowers(response.data.followersarr);
        setprojectName(response.data.projectname);
        setprojectId(response.data.project._id);
        sethours(response.data.hours);
        setPrice(response.data.price ?? 0);
        setstartDate(response.data?.startdate ?? "");
        setendDate(response.data?.enddate ?? "");
        setpriority(response.data.taskpriority);
        settaskStatus(response.data.taskstatus);
        //assign uploaded files
        setUploadedDocFiles(response?.data?.uploadedfiles);

        setchildTasks(response?.data?.childtasks);

        setMessageType("success");
      } else {
        setMessageType("error");
      }
      setAlertMessage(response.message);
    } catch (error) {
      setMessageType("error");
      setAlertMessage(error.message);
    }
    setShowAlert(true);
  };

  //save task
  const saveTaskHandler = async () => {
    try {
      setIsSaving(true);

      let taskData = {
        hours,
        startdate: startDate,
        enddate: endDate,
      };

      // console.log(taskData);

      let response = {};

      let requestUrl =
        url.API_BASE_URL +
        url.API_UPDATE_PROJECT_TASK +
        `/${selectedTaskId}?token=${token}`;

      response = await putData(requestUrl, taskData);

      setIsSaving(false);

      // console.log(response);

      if (response.status) {
        setShowTaskHourInput(false);
        setShowTaskDateInput(false);
        setMessageType("success");
        setTimeout(() => {
          getTaskDetails();
        }, 1000);
      } else {
        setMessageType("error");
      }
      setAlertMessage(response.message);
    } catch (error) {
      setMessageType("error");
      setAlertMessage(error.message);
    }

    setShowAlert(true);
  };

  useEffect(() => {
    if (selectedTaskId) {
      getTaskDetails();
    }
  }, [selectedTaskId]);

  return (
    <div className="p-4">
      <form onSubmit={(e) => e.preventDefault()}>
        <div className="form-group mb-4">
          {/* <!-- ========== Start task id and title Section ========== --> */}
          <div className="user_task_hdng mb-4">
            <h2>
              {customId ? (
                <span className="badge bg-dark me-3">{customId}</span>
              ) : null}
              {title}
            </h2>{" "}
          </div>
          {/* <!-- ========== End task id and title Section ========== --> */}

          {/* <!-- ========== Start other information Section ========== --> */}
          <div className="task_info_innr">
            {/* <!-- ========== Start task assigned user Section ========== --> */}
            <div className="task_info_row d-flex align-items-center gap-1 mb-2 py-2">
              <label className="fw-semibold">Assigned to</label>
              <div className="sign_prsn_outer d-flex align-items-center gap-2 flex-wrap">
                {userName === "" ? null : (
                  <div className="aign_usr_item bg-gray-300 rounded-8 px-2 py-1 d-flex align-items-center gap-1">
                    <span className="rounded-circle d-block usr_img">
                      <img
                        height={22}
                        className="rounded-circle"
                        src={
                          userImage == ""
                            ? assetImages.defaultUser
                            : url.SERVER_URL + userImage
                        }
                        alt=""
                      />
                    </span>
                    <span className="d-block">{userName}</span>
                  </div>
                )}
              </div>
            </div>
            {/* <!-- ========== End task assigned user Section ========== --> */}

            {/* <!-- ========== Start task followers Section ========== --> */}
            <div className="task_info_row d-flex align-items-center gap-1 mb-2 py-2">
              <label className="fw-semibold">Follower</label>
              {taskFollowers.length === 0 ? null : (
                <div className="sign_prsn_outer d-flex align-items-center gap-2 flex-wrap">
                  {taskFollowers.map((follower, index) => {
                    return (
                      <div
                        className="aign_usr_item bg-gray-300 rounded-8 px-2 py-1 d-flex align-items-center gap-1"
                        key={index}
                      >
                        <span className="rounded-circle d-block usr_img">
                          <img
                            height={22}
                            className="rounded-circle"
                            src={
                              follower.imagepath == ""
                                ? assetImages.defaultUser
                                : url.SERVER_URL + follower.imagepath
                            }
                            alt=""
                          />
                        </span>
                        <span className="d-block">{follower.label}</span>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
            {/* <!-- ========== End task followers Section ========== --> */}

            <div className="task_info_row d-flex align-items-center gap-1 mb-2 py-2">
              <label className="fw-semibold">Project</label>
              <h5 className="mb-0 text-black fs-md">{projectName}</h5>
            </div>
            <div className="task_info_row d-flex align-items-center gap-1 mb-2 py-2">
              <label className="fw-semibold">Status</label>
              <h5 className="d-flex align-items-center gap-1">
                <i className="material-symbols-outlined text-green fs-lg">
                  check_circle
                </i>
                <span className="text-black fs-md">{taskStatus}</span>
              </h5>
            </div>
            <div className="task_info_row d-flex align-items-center gap-1 mb-2 py-2">
              <label className="fw-semibold">Time(Hrs)</label>
              {showTaskHourInput ? (
                <div className="d-flex gap-2">
                  <input
                    min={0}
                    type="number"
                    className="form-control fs-sm shadow-none border border-1 bg-white"
                    value={hours}
                    onChange={(e) => sethours(e.target.value)}
                  />
                  <button
                    className="btn btn-primary fs-sm d-flex align-items-center"
                    onClick={saveTaskHandler}
                    style={{ cursor: isSaving ? "not-allowed" : "pointer" }}
                    disabled={isSaving ? true : false}
                  >
                    Save
                    {isSaving && (
                      <div
                        className="mx-2 spinner-border spinner-border-sm"
                        role="status"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    )}
                  </button>
                  <button
                    className="btn btn-secondary fs-sm"
                    onClick={() => setShowTaskHourInput(false)}
                  >
                    Cancel
                  </button>
                </div>
              ) : (
                <h5 className="d-flex align-items-center gap-1">
                  <i className="material-symbols-outlined text-orange fs-lg">
                    schedule
                  </i>
                  <span className="mb-0 text-black fs-md">{hours} Hrs</span>
                  <Link
                    to="#"
                    onClick={() => {
                      setShowTaskHourInput(!showTaskHourInput);
                    }}
                  >
                    <i className="material-symbols-outlined text-gray-600 fs-lg">
                      edit
                    </i>
                  </Link>
                </h5>
              )}
            </div>
            <div className="task_info_row d-flex align-items-center gap-1 mb-2 py-2">
              <label className="fw-semibold">Deadline</label>
              {showTaskDateInput ? (
                <div className="d-flex gap-2">
                  <input
                    type="date"
                    className="form-control fs-sm shadow-none border border-1 bg-white"
                    value={startDate}
                    onChange={(e) => setstartDate(e.target.value)}
                  />
                  <input
                    type="date"
                    className="form-control fs-sm shadow-none border border-1 bg-white"
                    value={endDate}
                    onChange={(e) => setendDate(e.target.value)}
                  />
                  <button
                    className="btn btn-primary fs-sm d-flex align-items-center"
                    onClick={saveTaskHandler}
                    style={{ cursor: isSaving ? "not-allowed" : "pointer" }}
                    disabled={isSaving ? true : false}
                  >
                    Save
                    {isSaving && (
                      <div
                        className="mx-2 spinner-border spinner-border-sm"
                        role="status"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    )}
                  </button>
                  <button
                    className="btn btn-secondary fs-sm"
                    onClick={() => setShowTaskDateInput(false)}
                  >
                    Cancel
                  </button>
                </div>
              ) : (
                <h5 className="d-flex align-items-center gap-1">
                  <i className="material-symbols-outlined fs-lg text-gray">
                    calendar_today
                  </i>
                  <span className="mb-0 text-black fs-md">
                    {getDateFormatInSpanish(startDate)} To{" "}
                    {getDateFormatInSpanish(endDate)}
                  </span>
                  <Link
                    to="#"
                    onClick={() => {
                      setShowTaskDateInput(!showTaskDateInput);
                    }}
                  >
                    <i className="material-symbols-outlined text-gray-600 fs-lg">
                      edit
                    </i>
                  </Link>
                </h5>
              )}
            </div>
            <div className="task_info_row d-flex align-items-center gap-1 mb-2 py-2">
              <label className="fw-semibold">Priority</label>
              <div className="piority_status d-inline-flex align-items-center py-1 px-2 rounded-10 bg-primary text-white fs-xs">
                {priority}
              </div>
            </div>
            <div className="task_info_row d-flex align-items-center gap-1 py-2">
              <label className="fw-semibold">Price (Euro)</label>
              <h5 className="d-flex align-items-center gap-1">
                <i className="material-symbols-outlined text-green fs-lg">
                  euro
                </i>
                <span className="mb-0 text-black fs-md">{price}</span>
              </h5>
            </div>
          </div>
          {/* <!-- ========== End other information Section ========== --> */}
        </div>

        {/* <!-- ========== Start task details Section ========== --> */}
        <div className="form-group mb-4">
          <label htmlFor="Details" className="d-block fs-sm fw-semibold mb-2">
            Details
          </label>
          <div className="details_para">
            <p dangerouslySetInnerHTML={{ __html: details }}></p>
          </div>
        </div>
        {/* <!-- ========== End task details Section ========== --> */}

        {/* <!-- ========== Child task details Section ========== --> */}
        <div className={childTasks.length > 0 ? "form-group mb-4" : "d-none"}>
          <label htmlFor="Details" className="d-block fs-sm fw-semibold mb-2">
            Child Tasks
          </label>
          <div className="details_para">
            {childTasks.map((task, index) => {
              return (
                <Link
                  to={`/admin/task/details/${task._id}`}
                  target="_blank"
                  className="fs-sm fw-semibold text-primary"
                  key={index}
                >
                  {task.customid}
                  {" - "}
                  {task.title}
                </Link>
              );
            })}
          </div>
        </div>
        {/* <!-- ========== End Child details Section ========== --> */}

        {/* <!-- ========== Start uploaded file Section ========== --> */}
        <div className="form-group mb-4">
          <label
            htmlFor="attachments"
            className="d-block fs-sm fw-semibold mb-2"
          >
            Attachments
          </label>
          <ul className="uploaded-files d-flex flex-wrap gap-3 p-0 m-0 mt-3">
            {uploadedDocFiles.map((file, index) => {
              const fileObj = {
                ...file,
                path: url.SERVER_URL + file.path,
              };

              return (
                <li
                  className="file d-flex file_gap align-items-center px-3 py-2 border border-gray rounded-3 shadow-sm"
                  key={index}
                >
                  <span className="material-symbols-outlined text-primary">
                    {getFileIcon(file.name)}
                  </span>
                  <p className="fw-medium text-truncate me-auto mb-0">
                    {file.name}
                  </p>
                  <Link
                    className="p-2 bg-light rounded-5 border border-gray-300"
                    to="#"
                    onClick={() => downloadFileHandler(fileObj)}
                  >
                    <span className="d-block material-symbols-outlined icon-md text-gray-600 fw-medium">
                      download
                    </span>
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>
        {/* <!-- ========== End uploaded file Section ========== --> */}
      </form>
    </div>
  );
};

export default ViewTaskTab;
